var AbstractViewModel = require("./AbstractViewModel")
var ConsumerInfoWS = require("../ws/ConsumerInfoWS")
var StartServiceTransactionWS = require("../ws/StartServiceTransactionWS")
var Phone = require("../lib/phone")

function BeginServiceViewModel(parent) {
  var self = this;

  // Predicate this ViewModel on the Abstract class of a View Model
  // This tacks on additional functionality, including the ability to
  // read URL query parameters, and an observable binding predicated
  // on another object's obcervable-bound variables
  AbstractViewModel.apply(this, arguments);

  self.consumerName = ko.observable(null);
  self.sanitisedConsumerName = ko.pureComputed(
    function () {
      var consumerName = this.consumerName();
      return (consumerName) ? consumerName.trim() : "";
    }, 
    this
  )
  self.language = ko.observable(null);
  self.notes = ko.observable(null);
  self.partySize = ko.observable(null);
  self.originatingQueueId = null;
  self.phone = ko.observable(null);
  self.queue = ko.observable(null);
  self.ticketClassifier = ko.observable(null);
  self.transactionType = ko.observable(null);
  self.canAutoPopulateNotes = false;

  // Service to grab consumer info
  self.consumerInfoWS = new ConsumerInfoWS(self);

  self.startServiceTransactionWS = new StartServiceTransactionWS(self);

  self.queue.subscribe(function (val) {
    self.originatingQueueId = val || null;
  });


  /**
   * Looks up a user by phone and if exists, populates the
   * name field
   *
   * @method checkForKnownConsumer
   * @returns none
   */
  self.checkForKnownConsumer = function (data, evt) {
    if (self.phoneIsValid()) {
      var phoneWithCC = self.phoneWithCountryCode(self.phone());
      var locationId = self.parent.queuesWS.getQueueById(self.originatingQueueId).locationId;

      self.consumerInfoWS.doRequest(function () {
        var infoName = self.consumerInfoWS.consumerName;
        if (infoName && !self.sanitisedConsumerName()) {
          self.consumerName(infoName);
        }

        if (self.canAutoPopulateNotes && !self.notes() && self.consumerInfoWS.notes()) {
          self.notes(self.consumerInfoWS.notes())
        }

      }, locationId, phoneWithCC)
    }
  };


  /**
   * Prevents non-numeric characters from being entered
   *
   * @method handlePartySizeKeyDown
   * @returns {Boolean}
   */
  self.handlePartySizeKeyDown = function (data, evt) {
    return (self.parent.isNumericInput(evt) || evt.keyCode === 8 || evt.keyCode === 46);
  };


  /**
   * Prevents non-numeric characters from being entered
   *
   * @method handlePartySizeKeyUp
   * @returns {Boolean}
   */
  self.handlePartySizeKeyUp = function (data, evt) {
    if (!(self.parent.isNumericInput(evt) || evt.keyCode === 8 || evt.keyCode === 46)) {
      return false;
    }

    var qMax = null;
    var qMin = null;
    var q = self.parent.queuesWS.getQueueById(self.queue());

    if (q.maxPartySize) {
      qMax = !qMax ? q.maxPartySize : Math.min(qMax, q.maxPartySize);
    }
    if (q.minPartySize) {
      qMin = !qMin ? q.minPartySize : Math.max(qMin, q.minPartySize);
    }

    if (qMin && Number(self.partySize()) < Number(qMin)) {
      self.partySize(qMin);
    }
    else if (qMax && Number(self.partySize()) > Number(qMax)) {
      self.partySize(qMax);
    }

    return true;
  };


  /**
   * Masks the phone number and looks up known consumers
   *
   * @method handlePhoneKeyUp
   * @returns none
   */
  self.handlePhoneKeyUp = function (data, evt) {
    self.maskPhone(data, evt);
    self.checkForKnownConsumer(data, evt);

    return true;
  };

  self.handlePhonePaste = function(data, evt) {
    setTimeout(function() {
      self.maskPhone(data, evt);
      self.checkForKnownConsumer(data, evt);
    });

    return true;
  };

	/**
	 * Removes the UI from view
	 *
	 * @method hide
	 * @returns none
	 */
  self.hide = function () {
    self.parent.showBeginService(false);
  }


	/**
	 * Returns a collection of languages from the location the selected
   * queue belongs to
	 *
	 * @method languages
	 * @returns {Array}
	 */
  self.languages = ko.computed(function () {
    var arr = [];

    if (self.queue() && self.queueModel()) {
      var location = self.parent.locationsWS.getLocationById(self.queueModel().locationId);

      if (location && location.language && location.language.length > 1) {
        location.language.forEach(function (lang) {
          var parts = lang.split('_');

          arr.push({ id: parts[0], name: self.parent.messagesWS.get('language.' + parts[0]) });
        });
      }
    }

    return arr;
  }, this, { deferEvaluation: true });


	/**
	 * Takes a string or number and returns a version of the number masked
	 * with the phone.mask pattern, or the original number if no mask is
	 * specified.
	 *
	 * @method maskPhone
	 */
  self.maskPhone = function (data, event) {
    var element = event.target;
    var key = event.keyCode || event.charCode;
    var isBackspaceOrDeleteKey = (key === 8 || key === 46);

    var normalisedNumber = Phone.normaliseTelephoneNumber(element.value)
    var maskedNumber = self.parent.maskPhone(normalisedNumber, isBackspaceOrDeleteKey)
    self.phone(maskedNumber)
  };


	/**
	 * Determines if the phone number entered is valid
	 *
	 * @method phoneIsValid
	 * @returns {Boolean}
	 */
  self.phoneIsValid = ko.computed(function () {
    return (self.phone()) 
      ? Phone.isValidTelephoneNumber(self.phoneWithCountryCode(self.phone())) 
      : false;
  }, this, { deferEvaluation: true });


	/**
	 * Formats a phone with the location default phone country code
	 *
	 * @method phoneWithCountryCode
	 * @param {String} phone
	 * @returns {String}
	 */
  self.phoneWithCountryCode = function (phone) {
    if (phone && self.queue()) {
      var location = self.parent.locationsWS.getLocationById(self.queueModel().locationId);
      if (location && location.defaultPhoneCountryCode) {
        return Phone.prefixWithCountryCode(location.defaultPhoneCountryCode, phone)
      } else {
        return Phone.normaliseTelephoneNumber(phone)
      }
    } else {
      return  Phone.normaliseTelephoneNumber(phone)
    }
  };


	/**
	 * Easy reference to the QueueModel specified by the selected Queue Id
	 *
	 * @method queueModel
	 * @returns {QueueModel | Null}
	 */
  self.queueModel = ko.computed(function () {
    var q = null;

    if (self.queue()) {
      q = self.parent.queuesWS.getQueueById(self.queue());
    }

    return q;
  }, this, { deferEvaluation: true });


	/**
	 * Override of the prototype method
	 *
	 * @method reset
	 * @returns none
	 */
  self.reset = function () {
    self.consumerName(null);
    self.language(null);
    self.notes(null);
    self.partySize(null);
    self.phone(null);
    self.queue(null);
    self.ticketClassifier(null);
    self.transactionType(null);
  }


	/**
	 * Service results of the selected Queue
	 *
	 * @method serviceResults
	 * @returns {Array}
	 */
  self.serviceResults = ko.computed(function () {
    return (self.queue() != null) ? self.queueModel().serviceResults : [];
  }, this, { deferEvaluation: true });


	/**
	 * Send the collected user info to the server to being a transaction
	 *
	 * @method startService
	 * @returns none
	 */
  self.startService = function () {
    var consumerName = self.sanitisedConsumerName();

    if (self.startServiceEnabled()) {
      self.startServiceTransactionWS.params = {};

      self.startServiceTransactionWS.addParam('queueId', self.queue());

      // queueLocation can differ from parent.parent.locationId if a user selects multiple locations at login and then starts service in a queue that isn't the first location
      self.startServiceTransactionWS.addParam('locationId', self.queueModel().locationId);

      if (self.transactionTypes().length < 1){
        self.transactionType(null);
      }

      if (self.transactionTypes().length > 0 && self.transactionType()) {
        self.startServiceTransactionWS.addParam('transactionType', self.transactionType());
      }

      if (self.partySize()) {
        self.startServiceTransactionWS.addParam('partySize', self.partySize());
      }

      if (self.phoneIsValid()) {
        self.startServiceTransactionWS.addParam('phone', self.phoneWithCountryCode(self.phone()));
      }

      if (consumerName && consumerName != '') {
        // If the name is multipart, split it up in order to pass a first and last name
        if (consumerName.indexOf(' ')) {
          // Split the name into parts
          consumerName = consumerName.split(' ');

          // Pull the first element as the first name
          self.startServiceTransactionWS.addParam('firstName', consumerName.shift());

          // Join all the other elements into the last name
          if (consumerName.length > 0) {
            self.startServiceTransactionWS.addParam('lastName', consumerName.join(' '));
          }
        }
        // Only one name provided, pass that as the first name
        else {
          self.startServiceTransactionWS.addParam('firstName', consumerName);
        }
      }

      if (self.ticketClassifier()) {
        self.startServiceTransactionWS.addParam('classifier', self.ticketClassifier());
      }

      if (self.language() != null) {
        self.startServiceTransactionWS.addParam('locale', self.language());
      }

      self.startServiceTransactionWS.addParam('notes', self.notes());

      self.startServiceTransactionWS.doRequest(function () {
        self.parent.activeServiceTransactionsWS.doRequest();
        if (self.ticketClassifier()) {
          self.parent.stationUpdateWS.clearParams();
          self.parent.stationUpdateWS.addParam('ticketClassifierId', self.ticketClassifier());
          self.parent.stationUpdateWS.doRequest();
        }
      });

      if (self.parent.selectedQueueIds.indexOf(self.queue()) === -1) {
        self.parent.selectedQueueIds.push(self.queue());
      }

      self.parent.showBeginService(false);
    }

    self.reset();
  };


	/**
	 * Whether enough information has been collected in order to begin
   * service
	 *
	 * @method startServiceEnabled
	 * @returns {Boolean}
	 */
  self.startServiceEnabled = ko.computed(function () {
    const phoneIsValid = self.phoneIsValid()
    const hasConsumerName = self.sanitisedConsumerName() !== "" 
    return (self.queue() && (phoneIsValid || hasConsumerName ));
  }, this, { deferEvaluation: true } );


	/**
	 * Returns a collection of TransactionTypes
	 *
	 * @method transactionTypes
	 * @returns {Array}
	 */
  self.transactionTypes = ko.computed(function () {
    return (self.queue() != null) ? self.queueModel().transactionTypes : [];
  }, this, { deferEvaluation: true });


	/**
	 * Whether or not to show party size
	 *
	 * @method showPartySize
	 * @returns {Boolean}
	 */
  self.showPartySize = ko.computed(function () {
    if (self.queue() && self.queueModel()) {
      var l = self.parent.locationsWS.getLocationById(self.queueModel().locationId);

      if (l) {
        return l.usePartySize;
      }
    }
    return false;
  }, this, { deferEvaluation: true });


	/**
	 * Whether or not to show transaction type. If there are transaction
   * types and no service results, or specifically configured
	 *
	 * @method showTransactionTypes
	 * @returns {Boolean}
	 */
  self.showTransactionTypes = ko.computed(function () {
    return self.transactionTypes().length > 0 && self.parent.messagesWS.get('suppress.transaction.types.in.start.service.dialog') !== 'true'; //&& self.serviceResults().length < 2
  }, this, { deferEvaluation: true });

  self.isPhoneRequired = ko.pureComputed(function () {
    var name = this.sanitisedConsumerName()
    return !(name)
  }, this)

  self.isNameRequired = ko.pureComputed(function () {
    var phone = this.phone()
    return !(phone)
  }, this)


  return self;
};

BeginServiceViewModel.prototype = AbstractViewModel.prototype;
BeginServiceViewModel.prototype.constructor = BeginServiceViewModel;

BeginServiceViewModel.prototype.enableAutoPopulateNotes = function enableAutoPopulateNotes() {
  this.canAutoPopulateNotes = true;
}

BeginServiceViewModel.prototype.disableAutoPopulateNotes = function enableAutoPopulateNotes() {
  this.canAutoPopulateNotes = false;
}

module.exports = BeginServiceViewModel
